<template>
	<el-dialog title="设备门禁规则绑定" class="device-binding-dialog" :visible.sync="visible" width="55%" :close-on-click-modal="false">
		<el-card shadow="never" >
			<el-transfer class="device-transfer" :titles="titles" filterable filter-placeholder="请输入设备名称" :button-texts="['移除', '添加']"
				v-model="deviceList" :data="deviceData">

				<div slot-scope="{ option }" :class="option.disabled ? 'offline' : 'online'">
					<div class="option_label">
						<span style="font-size: 14px; font-weight: 400;">{{ option.name }}</span>
            <span style="color: #b2b2b2;margin-left: 5px;">({{ option.sn }})</span>
					</div>
				</div>
			</el-transfer>
		</el-card>
		<div slot="footer" style="margin-top: 20px;">
			<el-button @click="visible = false">取消</el-button>
			<el-button type="primary" :loading="subLoading" @click="submitBind">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { DeviceRuleApi } from "@/api/nexus/deviceRule"
	export default {
		data() {
			return {
				//设备门禁规则id
				ruleId: '',
				visible: false,
				titles: ["未绑定设备", "已绑定设备"],
				//未设备集合
				deviceData: [],
				//已绑定设备集合
				deviceList: [],
				subLoading: false

			}
		},
		methods: {
			//提交
			async submitBind() {
				this.subLoading = true;
				// if (this.deviceList.length > 0) {
					let param = {
						timeRuleId: this.ruleId,
						deviceIds: this.deviceList
					}
					// console.log("提交数据", param);
					let {
						code,
						message
					} = await DeviceRuleApi.saveBindDeviceRegulation(param);
					if (code == 200) {
						this.$message.success("保存成功");
						this.visible = false;
					} else {
						this.$message.error(message)
					}


				// } else {
				// 	this.$message.error("请选择需要绑定的设备")
				// }
				this.subLoading = false;
			},
			//打开页面
			show(ruleId) {
				this.ruleId = ruleId;
				this.getNotBindDeviceList(ruleId);
				this.getBindDeviceList(ruleId);
				//延迟打开页面，不会出现数据闪现情况
				setTimeout(() => {
					this.visible = true;
				}, 300)
			},
			//查询未绑定设备
			async getNotBindDeviceList(ruleId) {
				let {
					code,
					data
				} = await DeviceRuleApi.notBindDeviceRegulationList(ruleId);
				if (code == 200) {
					this.deviceData = data.map(device => {
						return {
							key: device.id,
							label: device.name + device.sn,
              name: device.name,
              sn: device.sn,
							disabled: device.status !== 1
						}
					})
					console.log(this.deviceData)
				}
			},
			//查询已绑定设备
			async getBindDeviceList(ruleId) {
				let {
					code,
					data
				} = await DeviceRuleApi.bindDeviceRegulationList(ruleId);
				if (code == 200) {
					this.deviceList = data;
				}
			}

		}
	}
</script>

<style >
.device-transfer {
  --el-transfer-panel-width: 450px;
  --el-transfer-panel-body-height: 400px;
}
	.device-transfer .el-transfer-panel {
		width: 370px !important;
	}
.device-binding-dialog .el-dialog__body{
  padding: 10px!important;
}

.device-binding-dialog .el-checkbox__input.is-disabled + span.el-checkbox__label{
  color: #b2b2b2!important;
}
/*.device-binding-dialog .el-transfer-panel__item.el-checkbox{
  color: #303133;
}*/
.device-binding-dialog .el-checkbox__input.is-disabled .el-checkbox__inner{
  background-color: #edf2fc!important;
  border-color: #DCDFE6!important;
}
.device-transfer .online::after {
		margin-left: 10px;
		position: absolute;
		content: "";
		top: 50%;
		transform: translateY(-50%);
		left: 24px;
		width: 8px;
		height: 8px;
		background: #1ab137;
		border-radius: 50%;
	}

.device-transfer .offline::after {
		margin-left: 10px;
		position: absolute;
		content: "";
		top: 50%;
		transform: translateY(-50%);
		left: 24px;
		width: 8px;
		height: 8px;
		background: #ff0000;
		border-radius: 50%;
	}
.device-transfer .option_label{
		margin-left: 11px;
	}
</style>